import React, { useState } from 'react';
import { grey } from '@mui/material/colors';
import isNil from '../functions/isNil';
import makeStyles from '@mui/styles/makeStyles';
import { IQuestion } from './helixIcons';
import { IconButton, Popover, Link } from '@mui/material';
import InlineHelpContent from '../help/inlineHelpContent';
import { useTranslation } from 'react-i18next';

interface Props {
  helpkey: string;
  customContent?: React.ReactNode;
  rootStyle?: React.CSSProperties;
}

export default function InlineHelp(props: Props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const { t } = useTranslation();

  function handleRequestOpen(e: any) {
    e.preventDefault();
    setOpen(true);
    setAnchorEl(e.target);
  }

  const { helpkey, customContent, rootStyle } = props;
  const content = InlineHelpContent(helpkey) || {
    link: null,
    linkText: null,
  };
  const link = content.link || '';
  const linkText = isNil(content.linkText)
    ? t('Help unavailable')
    : content.linkText;
  const helpContent =
    customContent ||
    (!isNil(link) ? (
      <Link href={link} rel="noopener noreferrer" target="_blank">
        {linkText}
      </Link>
    ) : (
      linkText
    ));

  return (
    <div
      className={classes.root}
      style={rootStyle || {}}
      data-helpkey={props.helpkey}
    >
      <IconButton
        edge="end"
        onClick={e => handleRequestOpen(e)}
        className="material-icon-button"
        size="large">
        <IQuestion className={classes.icon} />
      </IconButton>
      <Popover
        className={classes.popover}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {<div className="ape-help-link">{helpContent}</div>}
      </Popover>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'help',
    verticalAlign: 'middle',
    display: 'inline-block',
    maxWidth: 50,
    textAlign: 'center',
  },
  popover: {
    padding: 20,
  },
  icon: {
    color: grey[400],
  },
}));
